import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/user/layout.tsx");
